// A request sequence per dataset prevents older responses from replacing newer filters.
function createRequestGate() {
  const versions = new Map()
  return {
    begin(key) {
      const version = (versions.get(key) || 0) + 1
      versions.set(key, version)
      return () => versions.get(key) === version
    },
    invalidate(key) { versions.set(key, (versions.get(key) || 0) + 1) }
  }
}
module.exports = {createRequestGate}
